/**
 * CSO 驾驶舱 · 大数据量租户判定
 *
 * 创智物联租户（tenantId = 720813）的数据量远大于其他租户，需要做两处收敛：
 * - 桑基图「影响金额」默认下限抬到 1 万，避免链路重叠到无法阅读；
 * - 驾驶舱隐藏按数据源映射的三张分析卡（采购成本分析 / 核心 KPI / 战略推进）。
 *
 * 两处共用本文件的判定，保证显隐与筛选取值永远同步。
 */
import store from '@/store'

export const LARGE_VOLUME_TENANT_ID = 720813

/**
 * 解析当前租户 id（数字）。
 * 优先取登录用户信息里的 tenant，其次取租户列表选中的 currentTenant；
 * 都取不到时返回 null，调用方按「非目标租户」处理。
 */
export function resolveTenantId() {
  try {
    const userInfo = store.getters.userInfo || {}
    const candidates = [
      userInfo.tenant && userInfo.tenant.id,
      (store.state.user.currentTenant || {}).id
    ]
    for (const value of candidates) {
      if (value === null || value === undefined || value === '') continue
      const id = Number(value)
      if (Number.isFinite(id)) return id
    }
    return null
  } catch (e) {
    return null
  }
}

/** 是否大数据量租户（创智物联）。 */
export function isLargeVolumeTenant() {
  return resolveTenantId() === LARGE_VOLUME_TENANT_ID
}
